import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
export default {
  name: "article-activity",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        type: 2
      },
      // 搜索表单

      form: {
        viewNum: "",
        praiseNum: ""
      },
      dialogVisible: false,
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    updateStatus: function updateStatus(row) {
      var _this2 = this;
      this.$confirm("是否继续?", "操作提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.setArticleStatus({
                id: row.id,
                status: row.status == 1 ? 2 : 1
              });
            case 1:
              _this2.$message.success("操作成功");
              _this2.getData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))).catch(function () {});
    },
    dataDialog: function dataDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pn = 1;
              }
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getArticleList(_this3.searchForm);
            case 1:
              res = _context3.v;
              _this3.tableData = res.data.list;
              _this3.total = res.data.count;
              _this3.tableLoading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    updateSort: function updateSort(row) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.sortLifestyleTag(row);
            case 1:
              _this4.$message.success("操作成功");
              _this4.getData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.setArticlePraise(_this5.form);
            case 1:
              _this5.getData();
              _this5.dialogVisible = false;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    deleteItem: function deleteItem(row) {
      var _this6 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this6.$api.deleteArticle({
                id: row.id
              });
            case 1:
              _this6.$message.success("操作成功");
              _this6.getData();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))).catch(function () {});
    },
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/article/activity/update",
        query: {
          id: row.id
        }
      });
    },
    comment: function comment(row) {
      this.$router.push({
        path: "/article/comment",
        query: {
          id: row.id
        }
      });
    }
  }
};